import { en } from '@/i18n/en';
import { ptBR } from '@/i18n/pt-BR';
import type { Dictionary, Locale } from '@/i18n/types';

export type { Dictionary, Locale };

export const detectLocale = (languages: readonly string[]): Locale => {
  const first = languages.find((language) => language.length > 0);
  return first?.toLowerCase().startsWith('en') === true ? 'en' : 'pt-BR';
};

export const dictionaryFor = (locale: Locale): Dictionary => (locale === 'en' ? en : ptBR);

/* Which language the page that embeds this one is written in. The browser's own language
   answers a different question, and inside the vammo.com home it answers it wrongly: the
   home is written in one language whatever the visitor's browser prefers.

   An unknown value returns null rather than falling back to Portuguese, so the caller can
   still tell "the host asked for a locale we do not carry" from "nobody asked". */
export const localeFromSearch = (search: string): Locale | null => {
  const requested = new URLSearchParams(search).get('lang')?.toLowerCase() ?? '';
  if (requested.startsWith('pt')) {
    return 'pt-BR';
  }
  if (requested.startsWith('en')) {
    return 'en';
  }
  return null;
};
